import { Navigate, Outlet } from "react-router-dom";
import AuthService from "../utils/AuthService";

function ProtectedRoute() {
  const expiry = AuthService.getTokenExpiryTime();

  // Not logged in OR token expired
  if (!AuthService.getUserInfo() || (expiry && expiry < new Date())) {
    AuthService.logOut();
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}

export default ProtectedRoute;
